export default {"src":"https://assets.eu.daedalus.fih.io/_next/static/media/lv.147ab8dc.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};